/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import {
  VehiclesApiProps,
  VehicleParams,
  VehicleApiProps,
} from './types';
import vehicle from './vehicle';

const vehicleTag = baseApi.enhanceEndpoints({ addTagTypes: [vehicle.tagType] });
const vehiclelApi = vehicleTag.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query<VehiclesApiProps, VehicleParams>(
      vehicle.getVehicles(),
    ),
    getSiteVehicles: builder.query<VehiclesApiProps, VehicleParams>(
      vehicle.getSiteVehicles(),
    ),
    getVehicle: builder.query<VehicleApiProps, number>(vehicle.getEntity()),
    addVehicle: builder.mutation<
    VehicleApiProps,
      Partial<VehicleApiProps>
    >(vehicle.addVehicle()),
    updateVehicle: builder.mutation<
      void,
      Pick<VehicleApiProps, 'id'> & Partial<VehicleApiProps>
    >(vehicle.updateEntity()),
    deleteVehicle: builder.mutation<
    { success: boolean; id: number }, number
  >(vehicle.deleteEntity()),
    getContractorVehicle: builder.query<VehicleApiProps, number>(vehicle.getContractorVehicle()),

  }),
  overrideExisting: false,
});

export const {
  useGetVehiclesQuery,
  useGetSiteVehiclesQuery,
  useGetVehicleQuery,
  useAddVehicleMutation,
  useUpdateVehicleMutation,
  useDeleteVehicleMutation,
  useGetContractorVehicleQuery,
} = vehiclelApi;
